/*!
 * Owned by Pankaj Maurya LLC. Copyright (c) 2026 Pankaj Maurya LLC.
 * It is copyrighted could not be used or reused without written permission from Pankaj Maurya LLC.
 * Contact: pankaj@pankajmaurya.com
 * Support: https://designflowdigitals.com
 */

(function() {
  var SECTION_ID = 'cart-drawer';
  var isUpdating = false;

  function routes() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      window.themeRoutesRoot ||
      '/';
    if (typeof root !== 'string' || !root) root = '/';
    if (root.length > 1 && root.slice(-1) !== '/') root += '/';
    return root;
  }

  function formActionIsCartAdd(form) {
    if (!form || !form.getAttribute) return false;
    var action = (form.getAttribute('action') || '').toLowerCase();
    return action.indexOf('cart/add') !== -1;
  }

  function appendSellingPlanToFormData(formData, form) {
    if (formData.get('selling_plan')) return;
    var scope = form.closest('.pp-section') || form.closest('[data-section-id]') || document;
    var planInput =
      scope.querySelector('input[name="selling_plan"]:checked') ||
      scope.querySelector('select[name="selling_plan"]') ||
      scope.querySelector('input[name="selling_plan"]');
    var sellingPlanId = planInput && planInput.value ? String(planInput.value) : '';
    if (sellingPlanId) formData.append('selling_plan', sellingPlanId);
  }

  function storeButtonOriginalLabel(btn) {
    if (!btn || btn.getAttribute('data-original-text')) return;
    var label = btn.tagName === 'INPUT' ? (btn.value || '').trim() : (btn.textContent || '').trim();
    btn.setAttribute('data-original-text', label);
  }

  function setAddButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      storeButtonOriginalLabel(btn);
      btn.disabled = true;
      if (btn.tagName === 'INPUT') btn.value = 'Wird hinzugefügt...';
      else btn.textContent = 'Wird hinzugefügt...';
    } else {
      var orig = btn.getAttribute('data-original-text') || '';
      btn.disabled = false;
      if (btn.tagName === 'INPUT') btn.value = orig || 'In den Warenkorb';
      else btn.textContent = orig || 'In den Warenkorb';
    }
  }

  function getDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function openDrawer() {
    var d = getDrawer();
    if (d) {
      d.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeDrawer() {
    var d = getDrawer();
    if (d) {
      d.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  window.CartDrawer = { open: openDrawer, close: closeDrawer };

  /* Close drawer events */
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-close]') || e.target.closest('[data-cart-drawer-overlay]')) {
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Loading state ── */
  function showLoading() {
    var panel = document.querySelector('[data-cart-drawer-panel]');
    if (!panel) return;
    if (panel.querySelector('.cd__loader')) return;
    var loader = document.createElement('div');
    loader.className = 'cd__loader';
    loader.innerHTML = '<div class="cd__spinner"></div>';
    panel.appendChild(loader);
  }

  function hideLoading() {
    document.querySelectorAll('.cd__loader').forEach(function(l) { l.remove(); });
  }

  /* ── Refresh drawer via Section Rendering API ── */
  function refreshDrawer() {
    showLoading();

    return fetch(routes() + '?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data[SECTION_ID];
        if (!html) {
          hideLoading();
          updateCartCounts();
          return;
        }

        var temp = document.createElement('div');
        temp.innerHTML = html;

        var drawer = getDrawer();
        var newDrawer = temp.querySelector('[data-cart-drawer]');

        if (newDrawer && drawer) {
          var wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = newDrawer.innerHTML;
          if (wasOpen) drawer.classList.add('is-open');
        }

        hideLoading();
        updateCartCounts();
      })
      .catch(function(err) {
        console.error('Cart drawer refresh failed:', err);
        hideLoading();
      });
  }

  document.addEventListener('cart:refresh', function() {
    refreshDrawer().then(function() { openDrawer(); });
  });

  window.CartDrawer.refresh = refreshDrawer;

  function updateCartCounts() {
    fetch(routes() + 'cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.hv2-cart-count, [data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        document.querySelectorAll('a[href*="/cart"] sup').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function() {});
  }

  /* ── AJAX Cart helpers ── */
  function cartChange(key, quantity) {
    if (isUpdating) return Promise.resolve();
    isUpdating = true;

    return fetch(routes() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function() { return refreshDrawer(); })
    .then(function() { isUpdating = false; })
    .catch(function(err) {
      console.error('Cart change failed:', err);
      isUpdating = false;
      hideLoading();
    });
  }

  function cartAdd(formData) {
    if (isUpdating) return Promise.resolve();
    isUpdating = true;

    return fetch(routes() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: formData
    })
    .then(function(r) {
      return r.json().then(function(json) {
        if (!r.ok) {
          var msg = (json && (json.description || json.message)) || 'In den Warenkorb fehlgeschlagen';
          var err = new Error(msg);
          err.payload = json;
          throw err;
        }
        return json;
      });
    })
    .then(function() {
      updateCartCounts();
      return refreshDrawer();
    })
    .then(function() {
      isUpdating = false;
      openDrawer();
    })
    .catch(function(err) {
      console.error('In den Warenkorb fehlgeschlagen:', err);
      isUpdating = false;
      hideLoading();
    });
  }

  /* ── Quantity +/- and Remove (event delegation) ── */
  document.addEventListener('click', function(e) {
    if (isUpdating) return;

    var minus = e.target.closest('[data-qty-minus]');
    if (minus) {
      e.preventDefault();
      e.stopImmediatePropagation();
      cartChange(minus.getAttribute('data-key'), Math.max(0, parseInt(minus.getAttribute('data-qty'), 10) - 1));
      return;
    }

    var plus = e.target.closest('[data-qty-plus]');
    if (plus) {
      e.preventDefault();
      e.stopImmediatePropagation();
      cartChange(plus.getAttribute('data-key'), parseInt(plus.getAttribute('data-qty'), 10) + 1);
      return;
    }

    var remove = e.target.closest('[data-remove-item]');
    if (remove) {
      e.preventDefault();
      e.stopImmediatePropagation();
      cartChange(remove.getAttribute('data-key'), 0);
      return;
    }
  }, true);

  /* ──────────────────────────────────────────────────────
     ADD TO CART: intercept the BUTTON CLICK, not form submit.
     The editor blocks form submit events but NOT button clicks.
     We prevent the click from ever triggering a form submission.
     ────────────────────────────────────────────────────── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest(
      'form [type="submit"], form button[name="add"]'
    );
    if (!btn) return;
    var form = btn.closest('form');
    if (!form || !formActionIsCartAdd(form)) return;

    if (isUpdating) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    var formData = new FormData(form);
    appendSellingPlanToFormData(formData, form);
    setAddButtonLoading(btn, true);

    cartAdd(formData).finally(function() {
      setAddButtonLoading(btn, false);
    });
  }, true);

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.tagName || form.tagName.toLowerCase() !== 'form') return;
    if (!formActionIsCartAdd(form)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (isUpdating) return;

    var submitter = e.submitter;
    var triggerBtn = null;
    if (
      submitter &&
      submitter.matches &&
      submitter.matches('button[type="submit"], input[type="submit"], button[name="add"]')
    ) {
      triggerBtn = submitter;
    } else {
      triggerBtn = form.querySelector('button[name="add"], [type="submit"]');
    }

    var formData = new FormData(form);
    appendSellingPlanToFormData(formData, form);
    setAddButtonLoading(triggerBtn, true);

    cartAdd(formData).finally(function() {
      setAddButtonLoading(triggerBtn, false);
    });
  }, true);

  function initCartAddButtonLabels(root) {
    var scope = root || document;
    scope.querySelectorAll('form').forEach(function(form) {
      if (!formActionIsCartAdd(form)) return;
      form.querySelectorAll('[type="submit"], button[name="add"]').forEach(function(btn) {
        storeButtonOriginalLabel(btn);
      });
    });
  }

  initCartAddButtonLabels();
  document.addEventListener('shopify:section:load', function(ev) {
    if (ev && ev.target) initCartAddButtonLabels(ev.target);
  });

  /* ── Cart icon click → open drawer ── */
  document.addEventListener('click', function(e) {
    var cartBtn = e.target.closest('.hv2-cart');
    if (cartBtn && !cartBtn.closest('[data-cart-drawer]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer();
      return;
    }

    var cartLink = e.target.closest('a[href*="/cart"]:not([href*="/checkout"]):not([href*="/cart/"])');
    if (cartLink && !cartLink.closest('[data-cart-drawer]') && !cartLink.closest('.cp-section')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer();
      return;
    }
  }, true);
})();
